import { useTranslation } from 'react-i18next';
import { toast, type ToastOptions, Zoom } from 'react-toastify';
import CircleXIcon from '@/components/icons/CircleXIcon';

type ToastTextProps = {
  children: string;
};

const ToastText = ({ children }: ToastTextProps) => {
  const { t, i18n } = useTranslation();
  const isTranslationKey = i18n.exists(children);

  return <p>{isTranslationKey ? t(children) : children}</p>;
};

export const showErrorToast = (message: string, options: ToastOptions = {}) => {
  toast.error(<ToastText>{message}</ToastText>, {
    toastId: 'error',
    position: 'top-center',
    transition: Zoom,
    hideProgressBar: true,
    closeButton: false,
    closeOnClick: true,
    icon: () => <CircleXIcon className="text-icon-error" aria-hidden />,
    ...options,
  });
};

export { default as ToastContainer } from '@/components/Toast/ToastContainer';
